import { QueryClient } from '@tanstack/react-query';

// Create a query client instance with default configuration
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Keep the previous page's data while the next page loads. Without this,
      // a page/filter change briefly makes `data` (and the derived `rowCount`)
      // undefined, which makes server-mode DataGrids clamp back to page 0 —
      // i.e. clicking "next page" snapped straight back to the first page.
      keepPreviousData: true,
    },
  },
});